<template>
  <section id="success">
    <div class="s-body-container">
      <div class="s-top-container">
        <a href="https://smartac.com">
          <img
            src="@shared/assets/img/logo/long-grey.png"
            alt="SmartAC.com"
            class="logo"
          >
        </a>
      </div>
      <div class="s-content-container">
        <div class="s-header">
          Success!
        </div>
        <div class="s-sub">
          Your account is all set
        </div>
      </div>
      <div class="s-bottom-container">
        <ProAppBody showQR />
      </div>
    </div>
  </section>
</template>

<script>
import ProAppBody from '@shared/components/proApp/ProAppBody.vue';

export default {
  name: 'ProPasswordSuccessView',
  metaInfo: {
    title: 'SmartAC.com | Password Success',
  },
  components: {
    ProAppBody,
  },
};
</script>

<style lang="scss">

section#success {
  background-color: #EDF2FF;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 48px;

  @media (max-width: 425px) {
    padding: 0 24px;
  }

  .s-body-container {
    padding-top: 12px;
    max-width: 800px;

    .s-top-container {
      margin-bottom: 12px;

      .logo {
        width: 80px;
        object-fit: contain;
      }
    }

    .s-content-container {
      background-color: $WHITE;
      color: $BLACK;
      padding: 24px 0;
      border-radius: 4px;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      @media (max-width: 425px) {
        padding: 12px 24px;
      }

      .s-header {
        font-size: 2.5rem;
        font-weight: 700;
        margin-bottom: 8px;
        text-align: center;
      }

      .s-sub {
        text-align: center;
        font-size: 1.5rem;
      }
    }
  }
}
</style>
